(() => {
  const root = document.querySelector('#sequence-story');
  if (!root) return;
  const screen = root.querySelector('.portrait-screen');
  const controls = screen.querySelector('.practice-controls');
  const start = screen.querySelector('#practice-button');
  const adjust = screen.querySelector('#practice-adjust');
  const sheet = screen.querySelector('#practice-tune');
  const duration = screen.querySelector('#duration-slider');
  const steps = [...screen.querySelectorAll('.duration-step')];
  const intensity = [...screen.querySelectorAll('[data-intensity]')];
  const touched = new Set();
  const presets = {
    Vinyasa: { pace: 'Natural', holds: 'Short', intensity: 'Steady' },
    Ashtanga: { pace: 'Natural', holds: 'Short', intensity: 'Strong' },
    Hatha: { pace: 'Slow', holds: 'Normal', intensity: 'Steady' },
    Yin: { pace: 'Slow', holds: 'Long', intensity: 'Gentle' },
    Restorative: { pace: 'Slow', holds: 'Long', intensity: 'Gentle' },
    'Gentle yoga': { pace: 'Slow', holds: 'Normal', intensity: 'Gentle' },
    'Slow flow': { pace: 'Slow', holds: 'Normal', intensity: 'Steady' },
    'Somatic Yoga': { pace: 'Slow', holds: 'Normal', intensity: 'Gentle' },
    'Chair yoga': { pace: 'Slow', holds: 'Normal', intensity: 'Gentle' }
  };
  function setIntensity(value) {
    intensity.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.intensity === value)));
    screen.dataset.intensity = value;
  }
  intensity.forEach(button => button.addEventListener('click', () => {
    touched.add('intensity');
    setIntensity(button.dataset.intensity);
  }));
  setIntensity('Steady');
  function updateSteps() {
    steps[0].disabled = Number(duration.value) <= 5;
    steps[1].disabled = Number(duration.value) >= 60;
  }
  steps.forEach((button, index) => button.addEventListener('click', () => {
    duration.value = String(Math.min(60, Math.max(5, Number(duration.value) + (index ? 5 : -5))));
    duration.dispatchEvent(new Event('input', { bubbles: true }));
  }));
  duration.addEventListener('input', updateSteps);
  // The existing dial updates its value directly for pointer/keyboard input.
  new MutationObserver(updateSteps).observe(screen.querySelector('#duration-dial'), { attributes: true, attributeFilter: ['aria-valuenow'] });
  updateSteps();
  function openSheet() {
    sheet.hidden = false;
    screen.classList.add('is-settings-open');
    controls.inert = true;
    start.inert = true;
    adjust.setAttribute('aria-expanded', 'true');
    sheet.querySelector('.tune-close').focus({ preventScroll: true });
  }
  function closeSheet(returnFocus = true) {
    sheet.hidden = true;
    screen.classList.remove('is-settings-open');
    controls.inert = false;
    start.inert = false;
    adjust.setAttribute('aria-expanded', 'false');
    if (returnFocus) adjust.focus({ preventScroll: true });
  }
  adjust.addEventListener('click', openSheet);
  sheet.querySelector('.tune-close').addEventListener('click', () => closeSheet());
  sheet.querySelector('.tune-done').addEventListener('click', () => closeSheet());
  sheet.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); closeSheet(); }
    if (event.key !== 'Tab') return;
    const focusable = [...sheet.querySelectorAll('button,select,input,summary')].filter(element => element.getClientRects().length && !element.disabled);
    const index = focusable.indexOf(document.activeElement);
    if (event.shiftKey && index === 0) { event.preventDefault(); focusable.at(-1).focus(); }
    else if (!event.shiftKey && index === focusable.length - 1) { event.preventDefault(); focusable[0].focus(); }
  });
  sheet.querySelectorAll('select').forEach(select => select.addEventListener('change', () => {
    touched.add(select.name);
    screen.dataset[select.name] = select.value;
  }));
  const style = screen.querySelector('#practice-select');
  function applyStyle() {
    const preset = presets[style.value];
    screen.dataset.style = style.value;
    ['pace', 'holds'].forEach(key => {
      if (touched.has(key)) return;
      sheet.querySelector(`#tune-${key}`).value = preset[key];
      screen.dataset[key] = preset[key];
    });
    if (!touched.has('intensity')) setIntensity(preset.intensity);
  }
  style.addEventListener('change', applyStyle);
  applyStyle();
  sheet.addEventListener('change', () => adjust.classList.add('is-customised'));
  // Native touch/trackpad scrolling, plus dragging with a desktop mouse.
  screen.querySelectorAll('.glass-pill-rail').forEach(rail => {
    let pointer = null, dragged = false;
    rail.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragged = false;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft };
    });
    rail.addEventListener('pointermove', event => {
      if (!pointer || pointer.id !== event.pointerId) return;
      if (!event.buttons) { pointer = null; rail.classList.remove('is-dragging'); return; }
      const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      if (!dragged && (Math.abs(dx) < 5 || Math.abs(dx) < Math.abs(dy))) return;
      dragged = true;
      rail.classList.add('is-dragging');
      if (!rail.hasPointerCapture(event.pointerId)) rail.setPointerCapture(event.pointerId);
      rail.scrollLeft = pointer.left - dx;
      event.preventDefault();
    });
    const finish = event => {
      if (pointer?.id !== event.pointerId) return;
      if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      pointer = null;
      rail.classList.remove('is-dragging');
      if (event.type === 'pointercancel') dragged = false;
    };
    rail.addEventListener('pointerup', finish);
    rail.addEventListener('pointercancel', finish);
    rail.addEventListener('click', event => {
      if (!dragged) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dragged = false;
    }, true);
  });
  // Arrow keys select and reveal options in each scrolling choice group.
  screen.querySelectorAll('.glass-pill-rail,.intensity-segments').forEach(group => {
    group.addEventListener('keydown', event => {
      const buttons = [...group.querySelectorAll('button')];
      const index = buttons.indexOf(document.activeElement);
      if (index < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const next = buttons[(index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length];
      next.focus({ preventScroll: true });
      next.click();
    });
  });
  // A sheet cannot remain keyboard-active after the phone rotates to its player.
  new MutationObserver(() => {
    if (!sheet.hidden && screen.inert) closeSheet(false);
  }).observe(screen, { attributes: true, attributeFilter: ['inert'] });
})();
